// import { Box, CssBaseline, CircularProgress, Typography, useMediaQuery, useTheme } from '@mui/material';
// import React, { useContext, useEffect, useRef, useState } from 'react';
// import { Tab, Tabs } from 'react-bootstrap';
// import TabContent from '../../../../../components/TabContent';
// import { WmcContext } from '../../../../../context/WmcContext';
// import { DATA_TYPE, PASS_KEY, WEB_KEY } from '../../../../../api/AxiosApi';
// import { getDateTimeForTab2 } from '../../../../../utils';
// import { AuthenticationContext } from '../../../../../context/AuthenticationContext';
// import { PrAnalysisApi, PrAnalysisTab2Api } from '../../../../../api/Api';

// function PrAnalysisTab3() {
//     const { spacing, breakpoints } = useTheme();
//     const { getWmSENS, GoToBottom, MenuLoading, getTabWmcMenu, getWmcDash, MenuItems } = useContext(WmcContext);
//     const { LoggedInUserInfo } = useContext(AuthenticationContext);
//     const LOGIN_ID = localStorage.getItem('LoginID');
//     const LOC_CODE = localStorage.getItem('LCODE');
//     const lgs = useMediaQuery(breakpoints.up('lg'));
//     const [FromDate, setFromDate] = useState(getDateTimeForTab2().LastDay);
//     const [ToDate, setToDate] = useState(getDateTimeForTab2().Today);
//     const [key, setKey] = useState('IRR'); // Default to IRR tab

//     useEffect(() => {
//         getTabWmcMenu(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY);
//     }, []);

//     useEffect(() => {
//         getWmSENS(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY, key, FromDate, ToDate);
//     }, [key]);

//     useEffect(() => {
//         getWmcDash(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY, key, DATA_TYPE, FromDate, ToDate);
//     }, [key]);

//     const messageRef = useRef();

//     useEffect(() => {
//         setTimeout(() => {
//             if (messageRef.current) {
//                 messageRef.current.scrollIntoView({
//                     behavior: 'smooth',
//                     block: 'end',
//                     inline: 'nearest',
//                 });
//             }
//         }, 300);
//     }, [GoToBottom]);

//     // Filter to get only Solar Irradiation tab
//     const solarTab = MenuItems?.find((item) => item?.MENU_ID === 'IRR');

//     return (
//         <>
//             <CssBaseline />
//             <Box mt={spacing(1)}>
//                 {solarTab ? (
//                     <Tabs
//                         id="controlled-tab-example"
//                         activeKey={key}
//                         onSelect={(k) => setKey(k)}
//                     >
//                         {MenuLoading ? (
//                             <CircularProgress />
//                         ) : (
//                             <Tab
//                                 eventKey={solarTab?.MENU_ID}
//                                 title={solarTab?.MENU_NAME}
//                             >
//                                 <TabContent
//                                     WM_TYPE={key}
//                                     tabTitle={solarTab?.MENU_NAME}
//                                     menuID={solarTab?.MENU_ID}
//                                     // unit={solarTab?.unit}
//                                 />
//                             </Tab>
//                         )}
//                     </Tabs>
//                 ) : (
//                     <Typography
//                         variant="body2"
//                         width={"100%"}
//                         textAlign={"center"}
//                     >
//                         Solar Irradiation tab not found
//                     </Typography>
//                 )}

//                 <div ref={messageRef}></div>
//             </Box>
//         </>
//     );
// }

// export default PrAnalysisTab3;


import { Box, CircularProgress, CssBaseline, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import TabContent from '../../../../../components/TabContent';
import { WmcContext } from '../../../../../context/WmcContext';
import { DATA_TYPE, PASS_KEY, WEB_KEY } from '../../../../../api/AxiosApi';
import { getDateTimeForTab2 } from '../../../../../utils';
import { AuthenticationContext } from '../../../../../context/AuthenticationContext';

function PrAnalysisTab3() {
    const { spacing, breakpoints } = useTheme();
    const { getWmSENS, GoToBottom, MenuLoading, getTabWmcMenu, getWmcDash, MenuItems } = useContext(WmcContext);
    const { LoggedInUserInfo } = useContext(AuthenticationContext);
    
    const LOGIN_ID = localStorage.getItem('LoginID');
    const LOC_CODE = localStorage.getItem('LCODE');
    
    const lgs = useMediaQuery(breakpoints.up('lg'));
    const [FromDate, setFromDate] = useState(getDateTimeForTab2().LastDay);
    const [ToDate, setToDate] = useState(getDateTimeForTab2().Today);
    const [key, setKey] = useState('');

    // ✅ Show only "ISO" (Solar Insolation) & "IRR" (Solar Irradiation)
    const solarTabs = MenuItems?.filter((item) => item?.MENU_ID === 'IRR');

    useEffect(() => {
        if (solarTabs.length > 0) {
            setKey(solarTabs[0].MENU_ID); // Set first available tab as default
        }
    }, [MenuItems]);

    useEffect(() => {
        getTabWmcMenu(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY);
    }, []);

    useEffect(() => {
        if (key) {
            getWmSENS(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY, key, FromDate, ToDate);
            getWmcDash(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY, key, DATA_TYPE, FromDate, ToDate);
        }
    }, [key]);

    const messageRef = useRef();

    useEffect(() => {
        setTimeout(() => {
            if (messageRef.current) {
                messageRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
        }, 300);
    }, [GoToBottom]);

    return (
        <>
            <CssBaseline />
            <Box mt={spacing(1)} bgcolor={'black'} color={'white'}>
                {solarTabs?.length > 0 ? (
                    <Tabs id="controlled-tab-example" activeKey={key} onSelect={(k) => setKey(k)}>
                        {MenuLoading ? (
                            <CircularProgress />
                        ) : (
                            solarTabs.map((item, index) => (
                                <Tab key={index} eventKey={item.MENU_ID} title={item.MENU_NAME}>
                                    <TabContent WM_TYPE={key} tabTitle={item.MENU_NAME} menuID={item.MENU_ID} />
                                </Tab>
                            ))
                        )}
                    </Tabs>
                ) : (
                    <Typography variant="body2" width="100%" textAlign="center">
                        Solar Insolation or Solar Irradiation tab not found
                    </Typography>
                )}

                <div ref={messageRef}></div>
            </Box>
        </>
    );
}

export default PrAnalysisTab3;
